<div class="container">
    <!-- Bouton de fermeture de la popup -->
    <mat-icon class="closeBtn" (click)="close(false)">close</mat-icon>
    <!-- {{videoUrl}} -->
    <div class="firstPart">
        <div class="videoContainer">
            <mat-spinner id="videoSpinner" [diameter]="50"></mat-spinner>
            @if (!templateDescriptionPictureUrl) {
                <video
                    autoplay="autoplay"
                    [controls]="videoUrl != null"
                    muted="{{ muted }}"
                    loop
                    class="media"
                    playsinline
                    src="{{ videoUrl }}"
                    id="mediaVideo"
                    #video
                ></video>
            }
            <br />
            @if (templateDescriptionPictureUrl) {
                <img id="mediaImage" class="media" [src]="templateDescriptionPictureUrl" alt="Template Description" />
            }
        </div>
        <div class="infoContainer">
            <h1 class="spotName">{{ template.name }}</h1>
            <p class="spotDuration">
                <mat-icon>restore</mat-icon><span>{{ template.duration }} s</span>
            </p>
            <p>Disponible en <strong> portrait et paysage</strong></p>

            @if (!template.notCompatibleWithThisSpot && seeNext) {
                <button class="selectButton" (click)="close(true)" mat-raised-button color="primary">
                    Choisir ce modèle
                </button>
            }
        </div>
    </div>
    <div class="detailContainer">
        <div class="stepperDescriptionContainer">
            <h4>
                Eléments modifiables dans la vidéo <span>({{ xmlTemplateProperty?.length }})</span>
            </h4>
            <div class="propertyList">
                @for (templateValue of xmlTemplateProperty; track $index) {
                    <div class="informationItem">
                        <span class="numberIndicator">
                            <span>{{ templateValue.step }}</span>
                        </span>
                        <p>
                            {{ templateValue.description }}
                        </p>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
